import React from "react"
import PropTypes from "prop-types"
import Alert from "react-bootstrap/Alert"
import * as styles from "./Styles/Alerts.module.scss"
interface AlertTypes {
  error: string
  notice: string
}

const Alerts: React.FC<AlertTypes> = (props) => (
  <div className={styles.alerts}>
    {props.error.length > 0 && (
      <Alert variant="danger" className={styles.box}>
        <Alert.Heading>エラー</Alert.Heading>
        <p>{props.error}</p>
      </Alert>
    )}
    {props.notice.length > 0 && (
      <Alert variant="success" className={styles.box}>
        <Alert.Heading>お知らせ</Alert.Heading>
        <p>{props.notice}</p>
      </Alert>
    )}
  </div>
)

export default Alerts
